/**
 * 农耕分支 (🌾 农业科技) - 共18项
 * 严格按照 docs/TECH_TREE_DESIGN.md 设计
 */

import type { Tech } from '../TechTypes';

export const NONGGENG_TECHS: Tech[] = [
  // 第一层：基础农业 (3项)
  {
    id: 'N001',
    name: '神农本草',
    description: '农业始祖',
    branch: 'nonggeng',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { farmIncome: 10 },
    },
    position: { x: 20, y: 10 },
    icon: '🌱',
  },
  {
    id: 'N002',
    name: '精耕细作',
    description: '耕作之法',
    branch: 'nonggeng',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { farmIncome: 10 },
    },
    position: { x: 50, y: 10 },
    icon: '🌾',
  },
  {
    id: 'N003',
    name: '蓄养六畜',
    description: '畜牧业',
    branch: 'nonggeng',
    tier: 1,
    cost: 100,
    researchTime: 1,
    prerequisites: [],
    effects: {
      bonuses: { farmIncome: 15 },
    },
    position: { x: 80, y: 10 },
    icon: '🐂',
  },

  // 第二层：进阶农业 (5项)
  {
    id: 'N011',
    name: '引渠灌溉',
    description: '水利农业',
    branch: 'nonggeng',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['N001'],
    effects: {
      bonuses: { farmIncome: 20 },
    },
    position: { x: 10, y: 25 },
    icon: '💧',
  },
  {
    id: 'N012',
    name: '曲辕深耕',
    description: '农具改良',
    branch: 'nonggeng',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['N002'],
    effects: {
      bonuses: { farmIncome: 20, buildSpeedBonus: 1.3 },
    },
    position: { x: 30, y: 25 },
    icon: '🔧',
  },
  {
    id: 'N013',
    name: '牧场扩张',
    description: '畜牧发展',
    branch: 'nonggeng',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['N003'],
    effects: {
      bonuses: { farmIncome: 25, trainSpeedBonus: 0.85 },
    },
    position: { x: 50, y: 25 },
    icon: '🐏',
  },
  {
    id: 'N014',
    name: '粮仓储备',
    description: '储粮之术',
    branch: 'nonggeng',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['N001', 'N002'],
    effects: {
      bonuses: { goldCapacity: 1.5 },
    },
    position: { x: 70, y: 25 },
    icon: '🏠',
  },
  {
    id: 'N015',
    name: '农耕历法',
    description: '节气农业',
    branch: 'nonggeng',
    tier: 2,
    cost: 200,
    researchTime: 2,
    prerequisites: ['N002'],
    effects: {
      bonuses: { farmIncome: 15 },
    },
    position: { x: 90, y: 25 },
    icon: '📅',
  },

  // 第三层：高级农业 (5项)
  {
    id: 'N021',
    name: '稻作轮耕',
    description: '稻作技术',
    branch: 'nonggeng',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['N011', 'N012'],
    effects: {
      bonuses: { farmIncome: 30 },
    },
    position: { x: 10, y: 45 },
    icon: '🍚',
  },
  {
    id: 'N022',
    name: '铁犁牛耕',
    description: '耕作革命',
    branch: 'nonggeng',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['N012', 'N013'],
    effects: {
      bonuses: { farmIncome: 30, buildSpeedBonus: 1.25 },
    },
    position: { x: 30, y: 45 },
    icon: '🐃',
  },
  {
    id: 'N023',
    name: '万顷良田',
    description: '田地扩张',
    branch: 'nonggeng',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['N014'],
    effects: {
      bonuses: { farmIncome: 20, goldCapacity: 1.2 },
    },
    position: { x: 50, y: 45 },
    icon: '🌳',
  },
  {
    id: 'N024',
    name: '战马培育',
    description: '良马之术',
    branch: 'nonggeng',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['N013'],
    effects: {
      bonuses: { cavalryAttack: 1.2, speedBonus: 1.15 },
    },
    position: { x: 70, y: 45 },
    icon: '🏇',
  },
  {
    id: 'N025',
    name: '民富国强',
    description: '富民之策',
    branch: 'nonggeng',
    tier: 3,
    cost: 350,
    researchTime: 3,
    prerequisites: ['N014', 'N015'],
    effects: {
      bonuses: { incomeBonus: 1.2, morale: 1.2 },
    },
    position: { x: 90, y: 45 },
    icon: '🏘️',
  },

  // 第四层：大师农业 (3项)
  {
    id: 'N031',
    name: '天府之国',
    description: '沃土天成',
    branch: 'nonggeng',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['N021', 'N023'],
    effects: {
      bonuses: { farmIncome: 40, trainSpeedBonus: 0.75 },
    },
    position: { x: 20, y: 65 },
    icon: '🏞️',
  },
  {
    id: 'N032',
    name: '千里马群',
    description: '马政大成',
    branch: 'nonggeng',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['N022', 'N024'],
    effects: {
      bonuses: { cavalryAttack: 1.2, cavalryCharge: 1.2, trainSpeedBonus: 0.7 },
    },
    position: { x: 50, y: 65 },
    icon: '🦄',
  },
  {
    id: 'N033',
    name: '太平盛世',
    description: '盛世之治',
    branch: 'nonggeng',
    tier: 4,
    cost: 500,
    researchTime: 4,
    prerequisites: ['N025'],
    effects: {
      bonuses: { morale: 1.5, taxBonus: 1.2 },
    },
    position: { x: 80, y: 65 },
    icon: '🎊',
  },

  // 第五层：终极农业 (2项) [互斥]
  {
    id: 'N041',
    name: '风调雨顺',
    description: '农业终极：粮食产出+60%，灾害免疫',
    branch: 'nonggeng',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['N031'],
    mutuallyExclusive: ['N042'],
    effects: {
      bonuses: { farmIncome: 60 },
    },
    position: { x: 35, y: 85 },
    nodeShape: 'hexagon',
    icon: '🌈',
    quote: '风调雨顺，国泰民安',
  },
  {
    id: 'N042',
    name: '国泰民安',
    description: '动员终极：全民动员，人口可转化为民兵',
    branch: 'nonggeng',
    tier: 5,
    cost: 800,
    researchTime: 5,
    prerequisites: ['N032', 'N033'],
    mutuallyExclusive: ['N041'],
    effects: {
      bonuses: { trainSpeedBonus: 0.5, morale: 1.3 },
    },
    position: { x: 65, y: 85 },
    nodeShape: 'hexagon',
    icon: '🏮',
    quote: '民为邦本，本固邦宁',
  },
];
